import "./assets/styles/index.css";
import "react-datepicker/dist/react-datepicker.min.css";

import { createRoot } from "react-dom/client";
import App from "./App";

import "./i18n";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(() => {
    if ("development".startsWith(process.env.NODE_ENV)) {
        // console.log(...args);
    }
});
